import { useClientTranslations } from "../../lib/i18n/client";
import type { CommunityGroup } from "../../services/educationService";
import styles from "./GroupCard.module.css";

interface GroupCardProps {
	group: CommunityGroup;
}

export function GroupCard({ group }: GroupCardProps) {
	const { t, direction } = useClientTranslations("education");
	const name = group.nameKey ? t(group.nameKey, group.name) : group.name;

	return (
		<button type="button" className={styles.card} dir={direction}>
			<div className={styles.icon} style={{ backgroundColor: group.iconColor }}>
				<img
					src="/images/education/icon-community-chat.svg"
					alt="Community"
					className={styles.iconSvg}
				/>
			</div>
			<div className={styles.content}>
				<span className={styles.name}>{name}</span>
				<span className={styles.discussions}>
					{t("groups.discussions", { count: group.discussionCount })}
				</span>
			</div>
			<svg
				className={styles.chevron}
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Navigate</title>
				<path
					d="M6 4L10 8L6 12"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</button>
	);
}
